import * as React from 'react';

import KeyInformationDetailsItem from 'bundles/unified-description-page-common/components/modules/key-information/KeyInformationDetailsItem';

import _t from 'i18n!nls/xdp';

const KeyInformationEarnCertificate = () => {
  return <KeyInformationDetailsItem title={_t('Earn a Certificate')} subtitle={_t('With paid plans')} />;
};

export default KeyInformationEarnCertificate;
